import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const GalleryIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.25" stroke="currentColor" strokeWidth="1.5" />
    <rect x="2.25" y="2.25" width="11.5" height="11.5" rx="0.2" stroke="currentColor" strokeWidth="0.5" />
    <path
      fill="currentColor"
      d="M8.5 10.0006C6.9 8.8006 3.83333 8.8339 2.5 9.0006V13.5005H13.5V10.5005C12.5 10.8338 10.1 11.2006 8.5 10.0006Z"
    />
    <rect x="9" y="4" width="3" height="3" rx="1.5" fill="currentColor" />
  </svg>
));
